import { call, put, takeLatest } from 'redux-saga/effects';
import { FETCH_IMPACT_REDIRECT_REQUEST } from '../actions/actionTypes';
import {
  fetchImpactRedirectFailure,
  fetchImpactRedirectLoading,
  fetchImpactRedirectSuccess,
} from '../actions/ImpactActions';
import { getImpactRedirectUrl } from '../services/pnb/impactRedirect.service';

function* fetchImpactRedirect(action: any) {
  try {
    yield put(fetchImpactRedirectLoading(true));
    const response: any = yield call(getImpactRedirectUrl, action.payload);
    if (response?.data?.status === 'SUCCESS' && response?.data?.url) {
      yield put(fetchImpactRedirectSuccess(response.data.url));
    } else {
      yield put(fetchImpactRedirectFailure(response?.data?.message || 'Failed to get IMPACT redirect URL'));
    }
  } catch (error: any) {
    yield put(fetchImpactRedirectFailure(error?.message || 'Unknown error'));
  } finally {
    yield put(fetchImpactRedirectLoading(false));
  }
}

export function* impactSaga() {
  yield takeLatest(FETCH_IMPACT_REDIRECT_REQUEST, fetchImpactRedirect);
}
